/** Bahasa Indonesia translations */
export const id = {
  // Brand / hero
  "brand.tagline":          "Alat shapefile profesional · hanya di browser",
  "welcome.eyebrow":        "Selamat Datang",
  "welcome.title.line1":    "Semua alat shapefile,",
  "welcome.title.line2":    "dalam satu tab browser.",
  "welcome.subtitle":       "Reproyeksi, konversi, validasi, buffer, sederhanakan, ukur, gabungkan, potong, dan konversi koordinat langsung di browser Anda. Data Anda tidak pernah meninggalkan perangkat.",
  "welcome.hint":           "Pilih alat dari roda donat untuk mulai",
  "welcome.card.fast":      "Sangat Cepat",
  "welcome.card.fast.desc": "Semua pemrosesan terjadi lokal di browser Anda.",
  "welcome.card.private":   "100% Privat",
  "welcome.card.private.desc": "File tidak pernah meninggalkan perangkat. Tanpa unggah.",
  "welcome.card.offline":   "Bekerja Offline",
  "welcome.card.offline.desc": "Setelah dimuat, semua alat berjalan tanpa internet.",
  "welcome.card.free":      "Selalu Gratis",
  "welcome.card.free.desc": "Alat GIS profesional tanpa biaya.",

  // Tool labels (donut)
  "tool.reproject":   "Reproyeksi",
  "tool.converter":   "Konversi",
  "tool.validate":    "Validasi",
  "tool.buffer":      "Buffer",
  "tool.simplify":    "Sederhanakan",
  "tool.calculate":   "Ukur",
  "tool.merge":       "Gabung",
  "tool.clip":        "Potong",
  "tool.coordinate":  "Koordinat",
  "tool.layout":      "Layout",
  "tool.visualize":   "Bagikan",
  "tool.share":       "Bagikan",

  // Bottom nav
  "nav.faq":      "FAQ",
  "nav.about":    "Tentang",
  "nav.feedback": "Masukan",
  "nav.blog":     "Blog",
  "nav.roadmap":     "Peta Jalan",
  "nav.roadmapHint": "Lihat yang direncanakan & selesai",
  "nav.help":        "Bantu developer",
  "nav.helpHint":    "Kirim masukan & lihat pembaruan terbaru",
  "help.title":      "Bantu developer",
  "help.subtitle":   "Kirim masukan atau minta fitur, dan lihat yang baru rilis.",
  "help.reqTitle":   "Kamu minta, kami garap",
  "help.reqNote":    "Permintaan asli dari pengguna seperti kamu. Kirim di bawah, masuk daftar ini lalu digarap.",
  "sheet.faqTitle":   "Pertanyaan yang Sering Diajukan",
  "sheet.faqDesc":    "Jawaban singkat tentang cara kerja Shp.Aid, format yang didukung, dan privasi.",
  "sheet.aboutTitle": "Tentang Shp.Aid",
  "sheet.aboutDesc":  "Teknologi, fitur, dan kredit pengembang.",
  "nav.blogHint":     "Panduan & tutorial GIS",

  // Donut
  "donut.reset":  "ketuk untuk reset",
  "donut.pick":   "pilih alat",

  // File uploader
  "upload.drop":     "Letakkan file di sini atau klik untuk memilih",
  "upload.supports": "Didukung: {formats}",
  "upload.maxsize":  "Ukuran maks: {size}",
  "upload.selected": "File terpilih",
  "upload.remove":   "Hapus file",

  // Tool panel
  "panel.tool":         "Panel Alat",
  "panel.map":          "Peta",
  "panel.map.show":     "Tampilkan pratinjau peta",
  "panel.map.hide":     "Sembunyikan pratinjau peta",
  "panel.map.pending":  "Jalankan alat untuk melihat hasil di peta",

  // Theme
  "theme.toggle":   "Ganti tema",
  "theme.to.dark":  "Ubah ke mode gelap",
  "theme.to.light": "Ubah ke mode terang",

  // Language
  "lang.toggle":  "Bahasa",
  "lang.en":      "English",
  "lang.id":      "Bahasa Indonesia",

  // Tool intros + I/O labels
  "io.in":  "Input",
  "io.out": "Output",
  "io.shp": "Shapefile (.zip, atau .shp + .dbf + .prj)",

  "intro.reproject":      "Ubah koordinat shapefile dari satu proyeksi (EPSG) ke proyeksi lain. Proyeksi sumber dideteksi otomatis dari .prj bila ada.",
  "intro.reproject.out":  "Shapefile ZIP (terproyeksi ulang)",
  "intro.converter":      "Konversi data geospasial antar-format. Pilih format Dari dan Ke, unggah, lalu unduh. CSV harus memuat kolom lon/lat.",
  "intro.converter.in":   "Shapefile, GeoJSON, CSV, KML/KMZ, atau GeoParquet",
  "intro.converter.out":  "Shapefile, GeoJSON, KML, CSV, GPX, atau DXF",
  "intro.validate":       "“Validasi” memeriksa kesalahan geometri (perpotongan sendiri, ring tak tertutup, titik duplikat). “Perbaiki” memperbaikinya otomatis dan menghapus fitur duplikat.",
  "intro.validate.out":   "Shapefile ZIP (diperbaiki)",
  "intro.buffer":         "Buat zona buffer di sekitar tiap fitur pada jarak tertentu. Jarak positif untuk memperbesar, negatif untuk memperkecil (buffer ke dalam).",
  "intro.buffer.in":      "Shapefile atau GeoJSON",
  "intro.buffer.out":     "Shapefile ZIP (poligon buffer)",
  "intro.simplify":       "Kurangi jumlah verteks pada garis dan poligon (Douglas–Peucker) sambil menjaga bentuk. Toleransi lebih tinggi = geometri lebih sederhana.",
  "intro.simplify.out":   "Shapefile ZIP (verteks lebih sedikit)",
  "intro.calculate":      "Ukur luas & keliling (poligon) dan panjang (garis) per fitur. Hasil bisa ditulis sebagai atribut atau diekspor ke CSV.",
  "intro.calculate.out":  "Shapefile ZIP (berisi field) atau CSV",
  "intro.merge":          "Gabungkan beberapa shapefile jadi satu. Tiap fitur ditandai file asalnya. Mencampur tipe titik/garis/poligon ditandai tidak kompatibel.",
  "intro.merge.in":       "Beberapa Shapefile (tipe geometri sama)",
  "intro.merge.out":      "Shapefile ZIP (gabungan)",
  "intro.clip":           "Pangkas fitur ke kotak pembatas (bounding box). Masukkan batas sebagai minX,minY,maxX,maxY atau kecilkan extent saat ini.",
  "intro.clip.out":       "Shapefile ZIP (terpotong)",
  "intro.visualize":      "Bagikan layer GIS dengan tautan terenkripsi AES-256 end-to-end langsung di browser tanpa server backend.",
  "intro.share":          "Bagikan layer GIS dengan tautan terenkripsi AES-256 end-to-end langsung di browser tanpa server backend.",
  "io.url":               "Tautan terenkripsi (AES-256)",
  "cv.batchTitle":        "Batch: {n} berkas → 1 ZIP",
  "cv.batchMax":          "maks {n} berkas",
  "cv.batchNote":         "Setiap berkas dikonversi terpisah, lalu dibungkus dalam satu ZIP. Berkas yang gagal tidak membatalkan yang lain.",
  "cv.batchReady":        "{n} berkas siap dikonversi",
  "cv.batchReadyDesc":    "Tekan Convert untuk mengunduh hasilnya sebagai satu ZIP.",
  "cv.batchProgress":     "{done}/{total} — {name}",
  "cv.batchDone":         "{n} berkas dikonversi, tersimpan sebagai {name}",
  "cv.batchPartial":      "{ok} berkas berhasil, {fail} gagal — lihat daftar di panel.",
  "csv.mapping":          "Kolom Koordinat",
  "csv.x":                "Kolom X (Bujur / Easting)",
  "csv.y":                "Kolom Y (Lintang / Northing)",
  "csv.crs":              "Sistem Koordinat Sumber",
  "csv.delimiter":        "Pemisah",
  "csv.decimal":          "Desimal",
  "csv.preview":          "Contoh nilai",
  "csv.pickCols":         "Pilih kolom X dan Y untuk melanjutkan.",
  "csv.reprojected":      "akan direproyeksi ke WGS84",
  "csv.rowsSkipped":      "{n} baris dilewati (koordinat kosong atau tidak valid).",
  "intro.layout":         "Susun peta siap cetak: pilih ukuran kertas (A4/A3/Letter) dan orientasi, atur skala, lalu ekspor ke PDF lengkap dengan judul, arah mata angin, skala garis, dan legenda.",
  "intro.layout.in":      "Layer di Studio Peta (SHP/GeoJSON)",
  "intro.layout.out":     "Layout peta PDF siap cetak",

  // Common tool actions / status
  "act.reproject":   "Reproyeksi Shapefile",
  "act.convert":     "Konversi & Unduh",
  "act.buffer":      "Buat Buffer",
  "act.simplify":    "Sederhanakan Geometri",
  "act.calculate":   "Hitung Pengukuran",
  "act.recalculate": "Hitung Ulang",
  "act.merge":       "Gabungkan Shapefile",
  "act.clip":        "Potong berdasar Extent",
  "act.download":    "Unduh Hasil",
  "act.downloadShp": "Unduh Shapefile",
  "act.exportCsv":   "Ekspor CSV",
  "act.validate":    "Validasi",
  "act.fix":         "Perbaiki Geometri",
  "act.reading":    "Membaca…",
  "act.processing": "Memproses…",
  "status.reading":      "Membaca file…",
  "status.processing":   "Memproses…",
  "status.complete":     "Selesai!",

  // Shared tool labels / toasts
  "lbl.uploadShp":   "Unggah Shapefile",
  "lbl.units":       "Satuan",
  "lbl.inputFormat": "Format Masukan",
  "lbl.from":        "Dari",
  "lbl.to":          "Ke",
  "proj.popular":    "Proyeksi Populer",
  "proj.other":      "Proyeksi Lainnya",
  "proj.selectSrc":  "Pilih EPSG sumber",
  "proj.targetEpsg": "Kode EPSG Target",
  "unit.kilometers": "Kilometer",
  "unit.meters":     "Meter",
  "unit.miles":      "Mil",
  "unit.feet":       "Kaki",
  "unit.hectares":   "Hektar",
  "unit.acres":      "Are",
  "toast.fileLoaded":   "File dimuat",
  "toast.featuresN":    "{n} fitur ditemukan",
  "toast.pointsN":      "{n} titik ditemukan",
  "toast.error":        "Kesalahan",
  "toast.noData":       "Tidak ada data",
  "toast.noDataDesc":   "Unggah file terlebih dahulu",
  "toast.rateLimit":    "Batas laju terlampaui",
  "toast.dlComplete":   "Unduhan selesai",
  "toast.savedAs":      "Disimpan sebagai {name}",
  "toast.dlFailed":     "Unduhan gagal",
  "toast.uploadError":  "Kesalahan unggah",

  // Reproject
  "rp.step1":        "1. Unggah Shapefile",
  "rp.step2":        "2. Proyeksi Sumber",
  "rp.step3":        "3. Proyeksi Target",
  "rp.detected":     "Terdeteksi: {info}",
  "rp.projDetected": "Proyeksi terdeteksi",
  "rp.projSrc":      "Sumber: EPSG:{code}",
  "rp.projUnknown":  "Proyeksi tidak diketahui",
  "rp.projUnknownD": "Silakan pilih proyeksi sumber secara manual",
  "rp.missingInfo":  "Informasi kurang",
  "rp.missingInfoD": "Pilih proyeksi sumber dan target",
  "rp.sameProj":     "Proyeksi sama",
  "rp.sameProjD":    "Proyeksi sumber dan target sama",
  "rp.complete":     "Reproyeksi selesai",
  "rp.completeD":    "Dikonversi dari EPSG:{src} ke EPSG:{tgt}",
  "rp.errTitle":     "Kesalahan reproyeksi",
  "rp.success":      "Reproyeksi selesai! Data Anda dikonversi dari EPSG:{src} ke EPSG:{tgt}. Klik Unduh untuk menyimpan hasil.",
  "rp.errNoPrj":     "File .prj hilang, proyeksi tak terdeteksi. Pilih proyeksi sumber secara manual.",
  "rp.errNoDbf":     "File .dbf hilang, tabel atribut diperlukan untuk shapefile.",
  "rp.errFormat":    "Format file tidak valid. Diharapkan: file .shp + .dbf + .prj atau paket .zip.",
  "rp.errRead":      "Gagal membaca shapefile",
  "rp.errFailed":    "Reproyeksi gagal",

  // Buffer
  "bf.distance":      "Jarak Buffer",
  "bf.invalidDist":   "Jarak tidak valid",
  "bf.enterNumber":   "Masukkan angka yang valid",
  "bf.complete":      "Buffer selesai",
  "bf.completeD":     "Buffer dibuat untuk {n} fitur",
  "bf.failed":        "Buffer gagal",
  "bf.statusProc":    "Membuat buffer…",
  "bf.statusDone":    "Buffer selesai!",

  // Simplify
  "sm.tolerance":     "Toleransi",
  "sm.level":         "Tingkat penyederhanaan",
  "sm.low":           "Rendah",
  "sm.medium":        "Sedang",
  "sm.high":          "Tinggi",
  "sm.highQuality":   "Kualitas tinggi (lebih lambat, lebih akurat)",
  "sm.complete":      "Penyederhanaan selesai",
  "sm.completeD":     "Verteks dikurangi {pct}%",
  "sm.failed":        "Penyederhanaan gagal",
  "sm.statusProc":    "Menyederhanakan…",
  "sm.statusDone":    "Penyederhanaan selesai!",
  "sm.reduction":     "Pengurangan verteks",
  "sm.toleranceHint": "Toleransi lebih tinggi = lebih banyak penyederhanaan",
  "sm.projHint":      " (CRS proyeksi, nilai dalam meter)",
  "sm.hqMode":        "Mode Kualitas Tinggi",
  "sm.statusDoneD":   "Disederhanakan! Verteks dikurangi {pct}%",

  // Calculate
  "cl.measurements":  "Pengukuran yang dihitung",
  "cl.area":          "Luas (untuk poligon)",
  "cl.length":        "Panjang (untuk garis)",
  "cl.perimeter":     "Keliling (untuk poligon)",
  "cl.complete":      "Perhitungan selesai",
  "cl.completeD":     "Menghitung pengukuran untuk {n} fitur",
  "cl.failed":        "Perhitungan gagal",
  "cl.statusProc":    "Menghitung pengukuran…",
  "cl.statusDone":    "Perhitungan selesai!",
  "cl.summary":       "Ringkasan",
  "cl.totalFeatures": "Total fitur",
  "cl.totalArea":     "Total luas",
  "cl.totalLength":   "Total panjang",
  "cl.totalPerim":    "Total keliling",
  "cl.geomTypes":     "Tipe geometri",
  "cl.featureDetails":"Detail fitur",
  "cl.csvExported":   "CSV diekspor",
  "cl.cFeature":      "Fitur",
  "cl.cType":         "Tipe",
  "cl.cArea":         "Luas",
  "cl.cLength":       "Panjang",
  "cl.cPerimeter":    "Keliling",
  "cl.showing":       "Menampilkan 100 pertama dari {n} fitur",

  // Merge
  "mg.uploadMulti":   "Unggah Shapefile untuk Digabung",
  "mg.filesToMerge":  "File untuk digabung ({n})",
  "mg.clearAll":      "Hapus semua",
  "mg.needTwo":       "Tambahkan minimal 2 file untuk menggabung",
  "mg.complete":      "Penggabungan selesai",
  "mg.completeD":     "Menggabung {files} file menjadi {feats} fitur",
  "mg.failed":        "Penggabungan gagal",
  "mg.statusProc":    "Menggabung file…",
  "mg.statusDone":    "Penggabungan selesai!",
  "mg.results":       "Hasil penggabungan",
  "mg.warning":       "Peringatan",
  "mg.filesAdded":    "Menambah {n} file",
  "mg.filesLoaded":   "File dimuat",
  "mg.notEnough":     "File kurang",
  "mg.crsError":      "Kesalahan CRS",
  "mg.crsWarning":    "Peringatan CRS",
  "mg.clickUpload":   "Klik untuk mengunggah beberapa Shapefile",
  "mg.uploadHint":    "Pilih beberapa file .zip atau komponen Shapefile terpisah",
  "mg.compatOk":      "✓ File kompatibel untuk digabung",
  "mg.sourceFiles":   "File sumber",
  "lbl.features":     "{n} fitur",

  // Clip
  "cp.method":        "Metode potong",
  "cp.bbox":          "Kotak pembatas",
  "cp.current":       "Kecilkan extent",
  "cp.bounds":        "Batas (minX, minY, maxX, maxY)",
  "cp.currentExtent": "Extent saat ini",
  "cp.noFeatures":    "Tidak ada fitur di extent",
  "cp.noFeaturesD":   "Extent pemotongan tidak memotong fitur apa pun",
  "cp.complete":      "Pemotongan selesai",
  "cp.completeD":     "Dipotong menjadi {n} fitur (dari {orig})",
  "cp.failed":        "Pemotongan gagal",
  "cp.statusProc":    "Memotong fitur…",
  "cp.statusDone":    "Dipotong menjadi {n} fitur!",
  "cp.results":       "Hasil pemotongan",
  "cp.clipped":       "Terpotong",
  "cp.retention":     "Tingkat retensi: {pct}%",
  "cp.invalidBbox":   "Kotak pembatas tidak valid",
  "cp.bboxFormat":    "Masukkan bbox dalam format: minX, minY, maxX, maxY",
  "cp.noExtent":      "Tidak dapat menentukan extent saat ini",
  "cp.useCurrent":    "Pakai extent saat ini",
  "cp.reduceHint":    "Memotong ke 50% bagian dalam extent data, mengecilkan tiap sisi 25%.",
  "cp.result":        "Hasil: {bbox}",
  "cp.currentBboxLabel": "Extent saat ini (BBox):",
  "cp.formatHint":    "Format: minX, minY, maxX, maxY",
  "cp.tabBbox":       "BBox Kustom",
  "cp.tabReduce":     "Kecilkan extent 50%",
  "cp.enterCoords":   "Masukkan koordinat dipisah koma",
  "cp.original":      "Asli",
  "cp.removed":       "Dihapus",
  "cp.tabShapefile":  "Berdasar shapefile",
  "cp.maskUpload":    "Shapefile mask (poligon)",
  "cp.maskHint":      "Unggah shapefile poligon sebagai batas pemotong. Harus sama CRS dengan sumber dan extent-nya tumpang tindih.",
  "cp.maskCurrent":   "Mask: {name}",
  "cp.maskLoaded":    "Mask dimuat",
  "cp.maskMissing":   "Tidak ada mask",
  "cp.maskMissingD":  "Unggah shapefile poligon sebagai pemotong",
  "cp.maskNeedSource":  "Unggah sumber dulu",
  "cp.maskNeedSourceD": "Unggah shapefile yang akan dipotong sebelum mask",
  "cp.maskNotPolygon":  "Mask harus poligon",
  "cp.maskNotPolygonD": "Shapefile mask harus berisi geometri Polygon/MultiPolygon",
  "cp.maskCrsMismatch": "CRS tidak cocok",
  "cp.maskCrsMismatchD":"Sumber EPSG:{src} tapi mask EPSG:{mask}. Reproyeksikan salah satu agar cocok.",
  "cp.maskNoOverlap":   "Tidak tumpang tindih",
  "cp.maskNoOverlapD":  "Extent mask tidak menumpang sumber, tidak ada yang akan dipotong.",

  // Validate & Fix
  "vl.tabValidate":   "Validasi",
  "vl.tabFix":        "Perbaiki kesalahan",
  "vl.complete":      "Validasi selesai",
  "vl.fixComplete":   "Perbaikan selesai",
  "vl.fixCompleteD":  "Memperbaiki {fixed} fitur, menghapus {removed} fitur tak dapat diperbaiki",
  "vl.failed":        "Validasi gagal",
  "vl.fixFailed":     "Perbaikan gagal",
  "vl.statusValidating": "Memvalidasi…",
  "vl.statusFixing":     "Memperbaiki geometri…",
  "vl.statusValidDone":  "Validasi selesai!",
  "vl.statusFixDone":    "Perbaikan selesai!",
  "vl.valid":         "Valid",
  "vl.invalid":       "Tidak valid",
  "vl.errors":        "Kesalahan",
  "vl.warnings":      "Peringatan",
  "vl.fixResults":    "Hasil perbaikan",
  "vl.fixedFeatures": "Fitur diperbaiki",
  "vl.fixLog":        "Log perbaikan",
  "vl.allValid":      "Semua geometri valid!",
  "vl.foundInvalid":  "Ditemukan {n} fitur tidak valid",
  "vl.totalFeatures": "Total fitur",
  "vl.removed":       "Dihapus",
  "vl.validateGeom":  "Validasi geometri, lalu perbaiki masalah yang ditemukan.",
  "vl.toolMode":      "Mode alat",
  "vl.results":       "Hasil validasi",
  "vl.validFeatures": "Fitur valid",
  "vl.invalidFeatures":"Fitur tidak valid",
  "vl.status":        "Status",
  "vl.removedFeatures":"Fitur dihapus",
  "vl.statusValid":   "✓ Valid",
  "vl.statusInvalid": "✗ Tidak valid",
  "vl.errorsLabel":   "Kesalahan:",
  "vl.fixLogLabel":   "Log perbaikan:",

  // Converter
  "cv.geojsonLoaded":   "GeoJSON dimuat",
  "cv.csvLoaded":       "CSV dimuat",
  "cv.shpLoaded":       "Shapefile dimuat",
  "cv.kmlLoaded":       "KML/KMZ dimuat",
  "cv.parquetLoaded":   "GeoParquet dimuat",
  "cv.complete":        "Konversi selesai",
  "cv.failed":          "Konversi gagal",
  "cv.uploadFmt":       "Unggah {fmt}",
  "cv.statusReading":   "Membaca file…",
  "cv.statusConverting":"Mengonversi…",
  "cv.statusDone":      "Konversi selesai!",

  // Coordinate converter
  "cd.datum":      "Semua konversi memakai datum WGS 84 (EPSG:4326)",
  "cd.mapView":    "Lihat di peta",
  "cd.mapHint":    "Tampilkan koordinat ini di peta interaktif",
  "cd.dd":         "Derajat Desimal (DD)",
  "cd.dms":        "Derajat Menit Detik (DMS)",
  "cd.utm":        "Universal Transverse Mercator (UTM)",
  "cd.lat":        "Lintang",
  "cd.lon":        "Bujur",
  "cd.zone":       "Zona",
  "cd.easting":    "Easting (m)",
  "cd.northing":   "Northing (m)",
  "cd.zoneInput":  "Zona (mis. 49S)",
  "cd.convert":    "Konversi",
  "cd.copy":       "Salin",
  "cd.copied":     "Tersalin",
  "cd.zoneRef":    "Referensi Zona UTM Indonesia",
  "cd.colLonRange":"Rentang Bujur",
  "cd.colProvinces":"Provinsi / Wilayah",
  "cd.accuracy":   "Catatan Akurasi",
  "cd.note1":      "Datum: WGS 84, standar untuk GPS dan pemetaan global (EPSG:4326).",
  "cd.note2":      "Presisi DD: 6 desimal ≈ 0,11 m di khatulistiwa.",
  "cd.note3":      "Presisi DMS: 4 desimal detik ≈ 0,03 m di khatulistiwa.",
  "cd.note4":      "Presisi UTM: 3 desimal (mm), memadai untuk survei.",
  "cd.note5":      "UTM valid dalam tiap zona 6°; distorsi membesar ke tepi zona.",
  "cd.note6":      "Tanpa koreksi geoid (EGM96/EGM2008) atau atmosfer.",
  "cd.hintLat":    "Derajat desimal, −90 sampai 90. Pakai titik untuk desimal; minus (−) untuk Selatan. mis. -6.200000",
  "cd.hintLon":    "Derajat desimal, −180 sampai 180. Pakai titik untuk desimal; minus (−) untuk Barat. mis. 106.816666",
  "cd.hintDegLat": "Derajat bulat, 0 sampai 90",
  "cd.hintDegLon": "Derajat bulat, 0 sampai 180",
  "cd.hintMin":    "Menit, 0 sampai 59",
  "cd.hintSec":    "Detik, 0 sampai 59.9999. Pakai titik untuk desimal.",
  "cd.hintZone":   "Nomor zona 1–60 + huruf hemisfer N atau S. mis. 49S",
  "cd.hintEasting":"Easting dalam meter, 100.000–900.000. Pakai titik untuk desimal. mis. 695143.214",
  "cd.hintNorthing":"Northing dalam meter. Pakai titik untuk desimal. mis. 9314278.623",
  "cd.errDD":      "Masukkan nilai lintang dan bujur yang valid.",
  "cd.errLat":     "Lintang harus antara -90° dan 90°.",
  "cd.errLon":     "Bujur harus antara -180° dan 180°.",
  "cd.errDMSNeg":    "Derajat, menit, dan detik harus angka positif — tanda arah (N/S/E/W) yang menentukan belahan bumi.",
  "cd.errDMS":     "Isi semua kolom DMS dengan angka valid.",
  "cd.errDMSLat":  "Lintang DMS tidak valid (D: 0-90, M: 0-59, S: 0-59.9999).",
  "cd.errDMSLon":  "Bujur DMS tidak valid (D: 0-180, M: 0-59, S: 0-59.9999).",
  "cd.errZone":    "Masukkan zona UTM (mis. 49S).",
  "cd.errEN":      "Masukkan nilai easting dan northing yang valid (meter).",
  "cd.errEast":    "Easting harus antara 100.000 m dan 900.000 m.",
  "cd.errOutRange":"Koordinat hasil di luar rentang geografis valid. Periksa zona / nilai.",
  "cd.errUtm":     "Konversi UTM gagal.",

  // FAQ
  "faq.title": "Pertanyaan yang Sering Diajukan",
  "faq.q1": "Apa itu Shapefile?",
  "faq.a1": "Shapefile adalah format data vektor geospasial yang dikembangkan Esri. Banyak dipakai untuk menyimpan fitur geografis seperti titik, garis, dan poligon beserta atributnya.",
  "faq.q2": "Apakah data saya aman?",
  "faq.a2": "Tentu. Semua pemrosesan terjadi sepenuhnya di browser Anda dengan JavaScript. File Anda tidak pernah meninggalkan komputer dan tidak diunggah ke server mana pun.",
  "faq.q3": "Berapa batas ukuran file?",
  "faq.a3": "Karena pemrosesan terjadi di browser, batasnya bergantung pada memori perangkat Anda. Kebanyakan komputer modern dapat menangani file hingga beberapa ratus megabita tanpa masalah.",
  "faq.q4": "Perlu instalasi?",
  "faq.a4": "Tidak perlu instalasi! Shp.Aid bekerja sepenuhnya di browser web Anda. Cukup kunjungi situs dan langsung gunakan alatnya.",
  "faq.q5": "Browser apa yang didukung?",
  "faq.a5": "Shp.Aid bekerja paling baik di browser modern seperti Chrome, Firefox, Safari, dan Edge. Disarankan memakai versi terbaru untuk performa optimal.",

  // About / Features
  "ft.fast": "Sangat Cepat",
  "ft.fastD": "Semua pemrosesan terjadi lokal di browser Anda memakai pustaka JavaScript setara WebAssembly. Tanpa bolak-balik server, tanpa waktu tunggu unggah.",
  "ft.private": "100% Privat",
  "ft.privateD": "File Anda tidak pernah meninggalkan perangkat. Tanpa telemetri, tanpa unggah. Data spasial Anda tetap milik Anda.",
  "ft.offline": "Bekerja Offline",
  "ft.offlineD": "Setelah halaman dimuat, semua alat berfungsi tanpa koneksi internet. Ideal untuk kerja lapangan dan lingkungan terisolasi.",
  "ft.free": "Selalu Gratis",
  "ft.freeD": "Tanpa langganan, tanpa biaya tersembunyi, tanpa paywall. Alat shapefile profesional tanpa biaya, selamanya.",
  "ft.proj": "Presisi Proj4",
  "ft.projD": "Reproyeksi koordinat dan konversi UTM ditenagai proj4js, mesin proyeksi yang sama dengan QGIS dan pipeline GDAL.",
  "ft.format": "Keluaran Multi-Format",
  "ft.formatD": "Ekspor hasil sebagai Shapefile (zip), GeoJSON, KML, CSV, atau TopoJSON langsung dari browser dengan satu klik.",
  "ft.preview": "Pratinjau Peta Langsung",
  "ft.previewD": "Alat spasial menyertakan pratinjau peta Leaflet inline agar Anda dapat memverifikasi zona buffer, extent potong, dan hasil geometri secara visual.",
  "ft.tools": "9 Alat Terintegrasi",
  "ft.toolsD": "Reproyeksi · Konversi · Validasi & Perbaiki · Buffer · Sederhanakan · Ukur · Gabung · Potong · Konversi Koordinat, semua dalam satu antarmuka mulus.",
  "ft.techStack": "Tumpukan Teknologi",
  "ft.runtime": "Runtime",
  "ft.runtimeV": "React 18 + TypeScript, sepenuhnya sisi-klien, tanpa backend",
  "ft.geospatial": "Geospasial",
  "ft.mapPreview": "Pratinjau peta",
  "ft.mapPreviewV": "React-Leaflet v4 dengan tile OpenStreetMap",
  "ft.bundler": "Bundler",
  "ft.bundlerV": "Vite 5 dengan SWC, build cepat, HMR instan",
  "ft.styling": "Penataan",
  "ft.stylingV": "Tailwind CSS + primitif Radix UI + token desain kustom",
  "ft.devBy": "Dikembangkan oleh",
  "ft.license": "Lisensi",
  "ft.licenseVal": "MIT · Gratis & Sumber Terbuka",
  "ft.footer": "Shp.Aid adalah alat berbasis browser. Data diproses lokal, tanpa kontak server.",

  // Feedback
  "fb.title":        "Kirim Masukan",
  "fb.subtitle":     "Kami ingin mendengar pendapat Anda tentang Shp.Aid",
  "fb.name":         "Nama",
  "fb.namePh":       "Nama Anda",
  "fb.email":        "Email",
  "fb.rating":       "Penilaian",
  "fb.message":      "Pesan",
  "fb.messagePh":    "Beri tahu pendapat Anda...",
  "fb.missing":      "Kolom belum lengkap",
  "fb.missingD":     "Isi semua kolom yang wajib",
  "fb.invalidEmail": "Email tidak valid",
  "fb.invalidEmailD":"Masukkan alamat email yang valid",
  "fb.tooMany":      "Terlalu banyak kiriman",
  "fb.sent":         "Masukan terkirim!",
  "fb.sentD":        "Terima kasih atas masukan Anda. Kami akan meninjaunya segera.",
  "fb.failed":       "Gagal mengirim",
  "fb.failedD":      "Coba lagi atau hubungi kami langsung",
  "fb.thankYou":     "Terima kasih atas masukan Anda!",
  "fb.reviewSoon":   "Kami akan meninjaunya segera.",
  "fb.cancel":       "Batal",
  "fb.send":         "Kirim Masukan",
  "fb.sending":      "Mengirim…",
  "fb.stars":        "{n} bintang",

  // Legal page
  "lg.back":       "Kembali ke Shp.Aid",
  "lg.title":      "Hukum",
  "lg.subtitle":   "Privasi, ketentuan, dan kredit sumber terbuka untuk Shp.Aid.",
  "lg.navPrivacy": "Kebijakan Privasi",
  "lg.navTerms":   "Ketentuan Penggunaan",
  "lg.navDisclaimer": "Penafian Akurasi",
  "lg.navAttr":    "Atribusi Sumber Terbuka",
  "lg.effective":  "Berlaku: 24 Mei 2026",
  "lg.pShortB":    "Ringkasnya:",
  "lg.pShort":     "Shp.Aid tidak mengumpulkan, menyimpan, mengirim, atau membagikan data Anda. Setiap file yang Anda muat diproses sepenuhnya di browser Anda. File Anda tidak pernah sampai ke server kami, karena tidak ada server yang menangani file Anda.",
  "lg.pCollectH":  "Data apa yang kami kumpulkan",
  "lg.pCollect1B": "Tidak ada file Anda.",
  "lg.pCollect1":  "Semua pemrosesan shapefile, GeoJSON, KML, CSV, GPX, dan DXF terjadi lokal di browser Anda memakai pustaka JavaScript (Turf.js, proj4js, shpjs). File asli dan keluaran konversi tidak pernah meninggalkan perangkat Anda.",
  "lg.pCollect2":  "Jika nanti kami menambahkan analitik penggunaan anonim (mis. Plausible), itu hanya melacak metrik agregat: alat mana yang diklik, seberapa sering situs dikunjungi, dan dari negara mana kunjungan berasal. Itu TIDAK PERNAH melacak isi file, nama file, atau informasi pengenal pengguna apa pun.",
  "lg.pThirdH":    "Layanan pihak ketiga yang kami hubungi",
  "lg.pThird1":    "Tile OpenStreetMap, hanya saat Anda membuka pratinjau peta langsung. Browser Anda meminta tile peta langsung dari openstreetmap.org. Kami tidak mem-proxy atau mencatat permintaan ini.",
  "lg.pThird2":    "Ikon penanda peta dibundel bersama aplikasi dan dilayani dari situs ini. Tidak ada CDN ikon pihak ketiga yang digunakan.",
  "lg.pCookieH":   "Cookie & penyimpanan lokal",
  "lg.pCookie":    "Shp.Aid tidak memasang cookie pelacak. Ia memakai localStorage browser hanya untuk mengingat preferensi Anda (tema, bahasa, opsi terakhir dipakai). Anda dapat menghapusnya kapan saja dari pengaturan browser.",
  "lg.pRightsH":   "Hak Anda (GDPR / CCPA)",
  "lg.pRights":    "Karena kami tidak menyimpan data pribadi, tidak ada yang perlu dihapus, diekspor, atau dikoreksi. Bila ada pertanyaan, hubungi pengelola lewat tombol Masukan di halaman utama.",
  "lg.tIntro":     "Dengan menggunakan Shp.Aid, Anda menyetujui ketentuan ini.",
  "lg.t1H":        "1. Deskripsi layanan",
  "lg.t1":         "Shp.Aid adalah kumpulan alat gratis, sumber terbuka, dan hanya-browser untuk mengolah data geografis (konversi shapefile, reproyeksi, buffer, penyederhanaan, pengukuran, penggabungan, pemotongan, konversi koordinat). Disediakan \"apa adanya\" tanpa jaminan tingkat layanan.",
  "lg.t2H":        "2. Lisensi",
  "lg.t2":         "Kode sumber Shp.Aid dirilis di bawah Lisensi MIT. Anda boleh menggunakan, menyalin, memodifikasi, dan mendistribusikan ulang secara bebas. Lihat berkas LICENSE di repositori untuk teks lengkap.",
  "lg.t3H":        "3. Penggunaan yang wajar",
  "lg.t3a":        "Jangan gunakan Shp.Aid untuk tujuan ilegal atau memproses data yang tidak berhak Anda proses.",
  "lg.t3b":        "Jangan mencoba menyerang, membebani, atau merekayasa balik versi aplikasi yang di-hosting.",
  "lg.t3c":        "Jangan mendistribusikan ulang aplikasi yang di-hosting di bawah merek lain tanpa atribusi.",
  "lg.t4H":        "4. Tanpa jaminan & batasan tanggung jawab",
  "lg.t4":         "SHP.AID DISEDIAKAN \"APA ADANYA\", TANPA JAMINAN APA PUN, TERSURAT MAUPUN TERSIRAT. Sejauh diizinkan hukum, penulis dan kontributor tidak bertanggung jawab atas kerugian apa pun akibat penggunaan perangkat lunak ini, termasuk kehilangan data, koordinat keliru, atau kerugian lanjutan dari keputusan yang dibuat berdasarkan keluarannya.",
  "lg.dLead":      "Shp.Aid adalah alat produktivitas, bukan instrumen survei bersertifikat.",
  "lg.dBody":      "Transformasi koordinat memakai datum WGS 84 (EPSG:4326) dan proj4js, mesin proyeksi yang sama dengan QGIS dan GDAL. Dalam rangkaian uji kami, galat bolak-balik berada pada orde 10⁻¹⁴ derajat (machine epsilon) dan akurasi luas poligon dalam 0,02 % dari nilai rujukan independen. Namun:",
  "lg.d1":         "Tanpa koreksi geoid (EGM96 / EGM2008). Untuk pekerjaan elevasi presisi tinggi, pakai alat geodetik khusus.",
  "lg.d2":         "Akurasi UTM menurun di dekat batas zona. Jika data Anda melintasi beberapa zona UTM, pertimbangkan reproyeksi ke satu zona sebelum pekerjaan presisi.",
  "lg.d3":         "Untuk aplikasi kadaster, rekayasa, navigasi, atau yang kritis-keselamatan, hasil harus diverifikasi secara independen memakai perangkat lunak dan prosedur survei bersertifikat.",
  "lg.dEnd":       "Penulis melepaskan seluruh tanggung jawab atas keputusan yang dibuat berdasarkan keluaran Shp.Aid tanpa verifikasi independen.",
  "lg.aIntro":     "Shp.Aid dibangun di atas pundak raksasa sumber terbuka. Terima kasih kepada:",
  "lg.footer":     "Shp.Aid · Dikembangkan oleh Jokopal · Lisensi MIT",

  // 404
  "nf.notfound": "Halaman tidak ditemukan",
  "nf.home":     "Kembali ke Beranda",

  // Errors
  "error.title":     "Terjadi kesalahan",
  "error.tool":      "Alat ini gagal. Coba lagi atau pilih alat lain.",
  "error.chunk":     "Tidak bisa memuat bagian aplikasi. Silakan muat ulang halaman.",
  "error.retry":     "Coba lagi",
  "error.reload":    "Muat ulang",
} as const;
